import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';
import { parseEnum } from '@/utils';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class RabbitSandalyeAyak extends Vue
{
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;

  product: ProductDefinition;

  seletedFoot: string = RabbitFoot.Krom;
  seletedTekerlekYaziSehpasi: string = RabbitTekerlekYaziSehpasi.Tekerleksiz;



  defHideObjects = [
    '_yyy',
  ];

  defShowObjects = [
    'rabbit_tekerleksiz_govde_yyy',
    'rabbit_tekerleksiz_krom_ayak_yyy',
  ];


  availableAnimations: AnimationDefinition[] = [];


  async created()
  {
    this.product = Store.getProductById('rabbit_sandalyeayak');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    //this.availableAnimations = this.product.animations as any;
    //this.availableAnimationsChanged();

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });


    if (Store.state.selection)
    {
      Store.state.selection.parts.forEach((element) =>
      {
        this.colorChanged(element.color, element.palette, element.id);
      });
      await this.changeFoot(Store.state.selection.foot);
      await this.changeTekerlekYaziSehpasi(Store.state.selection.tekerlekyazisehpasi);

    } else
    {
      await this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged()
  {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }



  mounted()
  {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection()
  {
    const selection = new RabbitSelection();
    selection.parts = [];
    selection.foot = RabbitFoot.Krom;
    selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.Tekerleksiz;

    this.product.defaults.parts.forEach((element) =>
    {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
   await this.changeFoot(RabbitFoot.Krom);
   await this.changeTekerlekYaziSehpasi(RabbitTekerlekYaziSehpasi.Tekerleksiz);

    this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.Tekerleksiz;
    this.seletedFoot = RabbitFoot.Krom;

  }

  async changeTekerlekYaziSehpasi(tekerlekyazisehpasi: RabbitTekerlekYaziSehpasi)
  {
    console.log(this.seletedFoot);
    console.log(this.seletedTekerlekYaziSehpasi);
    await this._configuratorService.hideObjects({ objects: ['_yyy'], operator: FilterOperators.Contains });

    if (this.seletedFoot === RabbitFoot.Krom)
    {
      if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.Tekerleksiz)
      {
        console.log("Tekerleksiz");
        await this._configuratorService.showObjects({ objects: ['rabbit_tekerleksiz_govde_yyy', 'rabbit_tekerleksiz_krom_ayak_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.Tekerleksiz;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.Tekerleksiz;

      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.Ikitekerlekli)
      {
        console.log("Ikitekerlekli");
        await this._configuratorService.showObjects({ objects: ['rabbit_2tekerlekli_govde_yyy', 'rabbit_2tekerlekli_krom_ayak_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.Ikitekerlekli;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.Ikitekerlekli;
      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.DortTekerlekli)
      {
        console.log("DortTekerlekli");
        await this._configuratorService.showObjects({ objects: ['rabbit_4tekerlekli_govde_yyy', 'rabbit_4tekerlekli_krom_ayak_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.DortTekerlekli;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.DortTekerlekli;
      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.KolcaksizMod1)
      {
        console.log("KolcaksizMod1");
        await this._configuratorService.showObjects({ objects: ['rabbit_mode1_govde_yyy', 'rabbit_mode1_ayak_krom_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.KolcaksizMod1;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.KolcaksizMod1;
      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.YaziSehpaliMod1)
      {
        console.log("YaziSehpaliMod1");
        await this._configuratorService.showObjects({ objects: ['rabbit_mode1_govde_yyy', 'rabbit_mode1_yazi_tahtali_ayak_krom_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.YaziSehpaliMod1;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.YaziSehpaliMod1;
      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.YaziSehpaliMod5)
      {
        console.log("YaziSehpaliMod5");
        await this._configuratorService.showObjects({ objects: ['rabbit_mode5_govde_yyy', 'rabbit_mode5_yazi_tahtali_ayak_krom_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.YaziSehpaliMod5;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.YaziSehpaliMod5;
      }
    }

    if (this.seletedFoot === RabbitFoot.SiyahBoyali)
    {
      if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.Tekerleksiz)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_tekerleksiz_govde_yyy', 'rabbit_tekerleksiz_siyah_boyali_ayak_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.Tekerleksiz;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.Tekerleksiz;

      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.Ikitekerlekli)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_2tekerlekli_govde_yyy', 'rabbit_2tekerlekli_siyah_boyali_ayak_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.Ikitekerlekli;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.Ikitekerlekli;
      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.DortTekerlekli)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_4tekerlekli_govde_yyy', 'rabbit_4tekerlekli_siyah_boyali_ayak_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.DortTekerlekli;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.DortTekerlekli;
      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.KolcaksizMod1)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode1_govde_yyy', 'rabbit_mode1_ayak_siyah_boyali_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.KolcaksizMod1;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.KolcaksizMod1;
      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.YaziSehpaliMod1)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode1_govde_yyy', 'rabbit_mode1_yazi_tahtali_ayak_siyah_boyali_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.YaziSehpaliMod1;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.YaziSehpaliMod1;
      }
      else if (tekerlekyazisehpasi === RabbitTekerlekYaziSehpasi.YaziSehpaliMod5)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode5_govde_yyy', 'rabbit_mode5_yazi_tahtali_ayak_siyah_boyali_yyy'], operator: FilterOperators.Contains });
        Store.state.selection.tekerlekyazisehpasi = RabbitTekerlekYaziSehpasi.YaziSehpaliMod5;
        this.seletedTekerlekYaziSehpasi = RabbitTekerlekYaziSehpasi.YaziSehpaliMod5;
      }
    }
  }

  async changeFoot(foot: RabbitFoot)
  {
    await this._configuratorService.hideObjects({ objects: ['_yyy'], operator: FilterOperators.Contains });

    if (foot === RabbitFoot.Krom)
    {
      if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.Tekerleksiz)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_tekerleksiz_govde_yyy', 'rabbit_tekerleksiz_krom_ayak_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.Ikitekerlekli)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_2tekerlekli_govde_yyy', 'rabbit_2tekerlekli_krom_ayak_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.DortTekerlekli)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_4tekerlekli_govde_yyy', 'rabbit_4tekerlekli_krom_ayak_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.KolcaksizMod1)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode1_govde_yyy', 'rabbit_mode1_ayak_krom_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.YaziSehpaliMod1)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode1_govde_yyy', 'rabbit_mode1_yazi_tahtali_ayak_krom_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.YaziSehpaliMod5)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode5_govde_yyy', 'rabbit_mode5_yazi_tahtali_ayak_krom_yyy'], operator: FilterOperators.Contains });
      }

      Store.state.selection.foot = RabbitFoot.Krom;
      this.seletedFoot = RabbitFoot.Krom;

    }

    if (foot === RabbitFoot.SiyahBoyali)
    {
      if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.Tekerleksiz)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_tekerleksiz_govde_yyy', 'rabbit_tekerleksiz_siyah_boyali_ayak_yyy'], operator: FilterOperators.Contains });

      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.Ikitekerlekli)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_2tekerlekli_govde_yyy', 'rabbit_2tekerlekli_siyah_boyali_ayak_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.DortTekerlekli)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_4tekerlekli_govde_yyy', 'rabbit_4tekerlekli_siyah_boyali_ayak_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.KolcaksizMod1)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode1_govde_yyy', 'rabbit_mode1_ayak_siyah_boyali_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.YaziSehpaliMod1)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode1_govde_yyy', 'rabbit_mode1_yazi_tahtali_ayak_siyah_boyali_yyy'], operator: FilterOperators.Contains });
      }
      else if (this.seletedTekerlekYaziSehpasi === RabbitTekerlekYaziSehpasi.YaziSehpaliMod5)
      {
        await this._configuratorService.showObjects({ objects: ['rabbit_mode5_govde_yyy', 'rabbit_mode5_yazi_tahtali_ayak_siyah_boyali_yyy'], operator: FilterOperators.Contains });
      }

      Store.state.selection.foot = RabbitFoot.SiyahBoyali;
      this.seletedFoot = RabbitFoot.SiyahBoyali;

    }
  }

  async colorChanged(color: any, palette: any, part: any)
  {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}


export class RabbitSelection
{
  parts: PartSelection[];
  foot: RabbitFoot;
  tekerlekyazisehpasi: RabbitTekerlekYaziSehpasi;
}
export class PartSelection
{
  id: string;
  palette: string;
  color: string;
  name: string;
}


enum RabbitFoot
{
  Krom = 'krom',
  GriBoyali = 'griboyali',
  SiyahBoyali = 'siyahboyali',

}

enum RabbitTekerlekYaziSehpasi
{
  Tekerleksiz = 'tekerleksiz',
  Ikitekerlekli = 'ikitekerlekli',
  DortTekerlekli = 'dorttekerlekli',
  KolcaksizMod1 = 'kolcaksizmod1',
  YaziSehpaliMod1 = 'yazisehpalimod1',
  YaziSehpaliMod5 = 'yazisehpalimod5',

}





// WEBPACK FOOTER //
// ./src/components/families/rabbit/RabbitSandalyeAyak.ts